import { Handle, Position } from '@xyflow/react';
import { WorkflowHandlerID } from '../../workflow/ui';
import { TNodeProps } from '../types/node';
import { BaseNode } from './BaseNode';
import { TARGET_HANDLE_CLASSNAME } from './helpers';

export const EndNode = (props: TNodeProps) => {
  return (
    <BaseNode {...props}>
      <Handle
        type="target"
        position={Position.Left}
        className={TARGET_HANDLE_CLASSNAME}
        id={WorkflowHandlerID.TARGET_LEFT}
      />
      <Handle
        type="target"
        position={Position.Top}
        className={TARGET_HANDLE_CLASSNAME}
        id={WorkflowHandlerID.TARGET_TOP}
      />
    </BaseNode>
  );
};
